export const PersonType = {
    manager: "manager",
    staff: "staff",
    tiwtor: "canolfanTiwtor",
    learner: "learner",
    schoolsTeacher: "schoolsTeacher",
    headOfWelsh: "headOfWelsh",
    wblManager: "wblManager"
}
